import { Component, Inject, OnInit} from '@angular/core';

import { ProductConfig } from 'app/product-designer-config';
import { PriceCalculationService } from 'core/price/price-calculation.service';
import { ProductService } from 'core/product/product.service';
import { EventTrackingService } from 'core/tracking/event-tracking.service';
import { Utils } from 'core/utils';

@Component({
  selector: 'additional-products-selection',
  templateUrl: './additional-products-selection.component.html',
  styleUrls: [ './additional-products-selection.component.scss' ],
})
export class AdditionalProductsSelectionComponent implements OnInit
{
  public productConfig: ProductConfig;

  public panelsExpanded: Array<boolean> = [];
  public trackById: Object = Utils.trackById;
  public getCurrentPriceConfig: Object = Utils.getCurrentPriceConfig;
  public objToArray: any = Utils.objectValuesToArray;
  public additionalProductsHaveFeatures: boolean = false;

  constructor(
      @Inject(ProductService) private productService,
      @Inject(EventTrackingService) private eventTrackingService,
      @Inject(PriceCalculationService) public priceCalculationService
      )
  {
    this.productConfig = this.productService.getCurrentProduct();
  }

  public ngOnInit(): void
  {
    this.additionalProductsHaveFeatures = this.productConfig
      .additionalProducts.some(p => this.getFeatureGroupsCount(p) > 0);
  }

  public selectedValueChanged(productId: string, groupId: string,
      featureId: string): void
  {
    for (const idx in this.productConfig.additionalProducts) {
      if (this.productConfig.additionalProducts[idx].id === productId) {
        this.productConfig.additionalProducts[idx].featureGroups[groupId]
            .selectedFeature = featureId;
      }
    }
  }

  public getSelectedFeatureMediaUrl(product: any, size: string = 'medium',
      group: any = undefined): string
  {
    if (!group) {
      group = this.getFirstFeatureGroup(product);
    }
    const feature = this.getSelectedFeature(product, group);
    const images = group.features[feature].image;

    let url = undefined;

    if (images) {
      switch (size) {
        case 'small':
          url = images.smallURL;
          break;
        case 'medium':
          url = images.mediumURL;
          break;
        case 'large':
          url = images.largeURL;
          break;
        default:
          url = images.mediumURL;
          break;
      }
    }

    if (!url && product.image && product.image.mediumURL) {
      url = product.image.mediumURL;
    }
    return url;
  }

  public getSelectedFeature(product: any, group: any = undefined): string
  {
    if (!group) {
      group = this.getFirstFeatureGroup(product);
    }

    return group.selectedFeature;
  }

  public getFeatureGroupsCount(product: any): number
  {
    return Utils.byKey(product.featureGroups).length;
  }

  public getFirstFeatureGroup(product: any): any
  {
    return Utils.byValue(product.featureGroups)[0];
  }

  public getFeaturesAsOptions(group: any): any
  {
    return this.objToArray(group.features).map(
        f => <any> {'label': f.shortName, 'value': f.id});
  }

  private addAdditionalProduct(productId: string): void
  {
    this.productConfig.selectedAdditionalProducts.push(productId);
    this.trackSelection(productId, 1);
  }

  private removeAdditionalProduct(productId: string): void
  {
    let index =
        this.productConfig.selectedAdditionalProducts.indexOf(productId, 0);
    if (index > -1) {
      this.productConfig.selectedAdditionalProducts.splice(index, 1);
      this.trackSelection(productId, 0);
    }
  }

  public setAdditionalProductIsSelected(
      productId: string, selected: boolean): void
  {
    if (selected) {
      this.addAdditionalProduct(productId);
    }
    else {
      this.removeAdditionalProduct(productId);
    }

    this.priceCalculationService.calculateTotalPrice();
  }

  public additionalProductIsSelected(productId: string): boolean
  {
    return (
        this.productConfig.selectedAdditionalProducts.indexOf(productId) > -1);
  }

  private trackSelection(productId: string, value: number): void
  {
    this.eventTrackingService.track({
      category: this.productService.getCurrentProduct().id,
      action: 'accessories_change',
      label: productId,
      value: value,
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/additional-products-selection/additional-products-selection.component.ts